import * as React from "react";
import styled from "styled-components";
import cat_with_bag from "../../assets/cat_with_bag.png";
import shopping_cat from "../../assets/shopping_cat.png";
import { useNavigate } from 'react-router-dom'; // Correct import for navigation hook
import { useState } from "react";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress'; // Import CircularProgress for loader
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import HomeIcon from '@mui/icons-material/Home';
import Tooltip from '@mui/material/Tooltip'; // Import Tooltip from Material-UI
import { API_BASE_URL } from '../../config/apiConfig';
import { headerLogo, spendTypeArrow } from '../../assets/images';

const productDetails = [
  {
    id: 1,
    title: "Save",
    description: "I want to save money on every product purchase",
    image: cat_with_bag,
    width: 75,
    height: 92
  },
  {
    id: 2,
    title: "Splurge",
    description: "I spend money lavishly and upgrade my products frequently",
    image: shopping_cat,
    width: 103,
    height: 92
  },
];

export function SpendType() {
  const navigate = useNavigate(); // Use the useNavigation hook for redirection
  const [selectedId, setSelectedId] = useState('student');
  const [subscriptionType, setSubscriptionType] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '' });
  const [loading, setLoading] = useState(false); // State to manage loading status

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission behavior
    setLoading(true); // Set loading to true when the submission starts
    const token = sessionStorage.getItem('token');
    let body = {
      profession: selectedId,
      subscriptionType: subscriptionType
    };

    if (!subscriptionType) {
      setSnackbar({ open: true, message: 'Please select a subscription type before submitting.' });
      setLoading(false); // Stop loading if there is an error
      return;
    }

    if (token && body) {
      try {
        const response = await fetch(`${API_BASE_URL}/user/update-profile`, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token
          },
          body: JSON.stringify(body)
        });
        const data = await response.json();
        console.log(data);
        navigate('/myLists'); // Redirect to MyLists screen
      } catch (error) {
        console.error('Error updating preference', error);
        setSnackbar({ open: true, message: 'Error updating profile.' });
      } finally {
        setLoading(false); // Stop loading after the request is complete
      }
    }
  };

  const handleSelect = (value,type) => {
    console.log(value,type);
    if(type === 'userType'){
      setSelectedId(value);
    }
    if(type === 'productDetails'){
      setSubscriptionType(value);
    }
  };
  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }
    setSnackbar({ open: false, message: '' });
  };
  return (
    <MainContainer>
      <ContentWrapper>
        <LeftColumn>
          <LeftColumnContent>
          <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'10px'}}>

          <Logo onClick={() =>  window.open("/", "_blank")} src={headerLogo} alt="Logo" />
{/*                         <HomeIcon onClick={() => navigate("/")} style={{ width: '30px', height: '30px', cursor: 'pointer' }} />
 */}
                        </div>           
                         <Heading>Few more details!</Heading>
            <StepIndicator>Step 02 / 04
            <Tooltip title="Click here to learn more about us.." arrow> {/* Tooltip added here */}
            <InfoIcon onClick={() => window.open("/about", "_blank")}>
            <InfoOutlinedIcon style={{ width: '16px', height: '16px',backgroundColor:'#e9fe53', borderRadius:'100px'}} />
                                </InfoIcon>
                            </Tooltip>
            </StepIndicator>
            <ProgressBar>
              <ProgressIndicator />
            </ProgressBar>
            <NextStep>Next: My lists</NextStep>
          </LeftColumnContent>
        </LeftColumn>

        <RightColumn>
          <FormContainer>
            <FormWrapper onSubmit={handleSubmit}> {/* Add onSubmit handler to the form */}
              <Label htmlFor="name">I am</Label>
              <SelectField id="name" onChange={(e) => handleSelect(e.target.value,'userType')}>
                <option value="student">A student</option>
                <option value="professional">A working professional</option>
                <option value="startup">A startup founder</option>
                <option value="business">A business owner</option>
                <option value="institution">An institution</option>
              </SelectField>
              <Label htmlFor="productDetails">I want to</Label>
              <ProductDetailsWrapper>
                <ProductDetailsGrid>
                  {productDetails.map((product) => (
                    <ProductOption key={product.id} onClick={() => handleSelect(product.title,'productDetails')}>
                      <ProductDetails>
                        <ProductIcon /* src={product.icon}  */alt={product.title} isSelected={subscriptionType === product.title} />
                        <ProductTitle>{product.title}</ProductTitle>
                        <ProductDescription>{product.description}</ProductDescription>
                      </ProductDetails>
                      <ProductImage src={product.image} alt={product.title} width={product.width} height={product.height} />
                    </ProductOption>
                  ))}
                </ProductDetailsGrid>
              </ProductDetailsWrapper>
              <SubmitButton type="submit">
                {loading ? <CircularProgress size={24} /> : <ButtonText>Submit</ButtonText>} {/* Display loader or button text based on loading state */}
                <ArrowIcon src={spendTypeArrow} alt="Arrow Icon" />
              </SubmitButton>
            </FormWrapper>
           
          </FormContainer>
        </RightColumn>
      </ContentWrapper>
     
      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                                <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
                                    {snackbar.message}
                                </Alert>
                            </Snackbar>
                            <FooterWrapper>
        <NavigationLinks>
          <Link onClick={() => window.open("/", "_blank")}>Home</Link>
          <Link onClick={() => window.open("/about", "_blank")}>About Us</Link>
        </NavigationLinks>
        <Copyright>
          Copyright © 2024. SPOELT. All rights reserved
        </Copyright>
      </FooterWrapper>
    </MainContainer>
  );
}

const MainContainer = styled.main`
  background-color: #fff;
  padding: 39px 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  @media (max-width: 991px) {
    padding: 0 20px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }
`;

const LeftColumn = styled.section`
  width: 35%;
  margin-left: 0;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const LeftColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 991px) {
    margin-top: 40px;
  }
`;

const Logo = styled.img`
  width: 130px;
  max-width: 100%;
  object-fit: contain;
  cursor: pointer; // Added cursor pointer for logo
  `;
  
  const InfoIcon = styled.div`
    width: 10px; // Adjust size as needed
    margin-left: 5px; // Space between text and icon
    cursor: pointer; // Added cursor pointer for info icon
  `;

const Heading = styled.h1`
  color: #202023;
  margin-top: 129px;
  font: 800 60px/65px Inter, sans-serif;
  @media (max-width: 991px) {
    margin-top: 30px;
    margin-bottom: 10px;
    font-size: 40px;
    line-height: 48px;
  }
`;

const StepIndicator = styled.p`
display: flex;
flex-direction: row;
  color: #202023;
  letter-spacing: -0.24px;
  margin-top: 30px;
  font: 400 12px/130% Metrophobic, sans-serif;
  @media (max-width: 991px) {
    margin-top: 10px;
  }
`;

const ProgressBar = styled.div`
  border: 1px solid rgba(32, 32, 35, 1);
  display: flex;
  margin-top: 8px;
  padding: 1px 0;
  @media (max-width: 991px) {
    padding-right: 20px;
  }
`;

const ProgressIndicator = styled.div`
  background-color: #e9fe53;
  width: 50%;
  height: 12px;
`;

const NextStep = styled.p`
  color: #202023;
  letter-spacing: -0.24px;
  margin-top: 9px;
  font: 400 12px/130% Metrophobic, sans-serif;
`;

const RightColumn = styled.section`
  width: 65%;
  margin-left: 20px;
  @media (max-width: 991px) {
    width: 100%;
    margin-left: 0;
  }
`;

const FormContainer = styled.div`
  display: flex;
  margin-top: 69px;
  flex-grow: 1;
  flex-direction: column;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 10px;
  }
`;

const FormWrapper = styled.form`
  border: 1px solid rgba(32, 32, 35, 1);
  display: flex;
  flex-direction: column;
  padding: 53px 40px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const Label = styled.label`
  color: #202023;
  letter-spacing: -0.24px;
  text-transform: uppercase;
  font: 400 12px/130% Metrophobic, sans-serif;
  @media (max-width: 991px) {
   margin-top: 10px;
  }
`;

const SelectField = styled.select`
font:  16px/130% Metrophobic, sans-serif;
gap: 20px;
margin-bottom: 30px;
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  display: flex;
  margin-top: 10px;
  width: 49%;
  max-width: 100%;
  padding: 22px 15px;
  @media (max-width: 991px) {
    padding: 10px 15px;
    width: 100%;
    margin-bottom: 10px;
  };
`;

const ProductDetailsWrapper = styled.div`
  margin-top: 10px;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const ProductDetailsGrid = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 991px) {
    flex-direction: column;
    gap: 0;
  }
`;

const ProductOption = styled.div`
width: 50%;
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-left: 10px;
  cursor: pointer;
  @media (max-width: 991px) {
    margin-top: 10px;
    padding: 10px 0px 0px 10px;
    width: auto;
  }
`;

const ProductDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const ProductIcon = styled.div`
  width: 8px;
  height: 8px;
  fill: #e9fe53;
  border: 1px solid #000; /* Default state */
  border-radius: 50%;
  padding: 5px;
  background-color: ${props => props.isSelected ? "#e9fe53" : "transparent"};
  position: relative; /* Added for positioning the tick mark */
  &:after {
    content: ${props => props.isSelected ? "'✓'" : "''"};
    color: #202023;
    font-size: 12px;
    position: absolute;
    top: 50%; /* Center vertically */
    left: 50%; /* Center horizontally */
    transform: translate(-50%, -50%); /* Adjust for the size of the tick */
  }
`;

const ProductTitle = styled.div`
  margin-top: 16px;
  font: 800 16px/130% Inter, sans-serif;
  @media (max-width: 991px) {
    margin-top: 10px;
  }
`;

const ProductDescription = styled.p`
  letter-spacing: -0.24px;
  margin-top: 10px;
  font: 400 12px/16px Metrophobic, sans-serif;
`;

const ProductImage = styled.img`
 /*  width: 75px;
  height: 94px; */
`;

const SubmitButton = styled.button`
display: flex;
justify-content: space-between;
align-items: center;
border: 1px solid rgba(32, 32, 35, 1);
border-radius: 1px;
background-color: #e9fe53;
gap: 8px;
width: 49%;
margin-top: 10px;
text-transform: uppercase;

color: #202023;
white-space: nowrap;
flex: 1;
padding: 15px 13px;
@media (max-width: 991px) {
  padding-right: 20px;
  white-space: initial;
  width: 100%;
  margin-bottom: 20px;
}
`;

const ButtonText = styled.span`
font:  16px/130% Metrophobic, sans-serif;
`;

const ArrowIcon = styled.img`
width: 11px;
object-fit: contain;
fill: #202023;
`;



const Footer = styled.footer`
  color: #828282;
  align-self: end;
  margin-top: 95px;
  font: 400 12px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    margin-top: 40px;
  }
`;
const Copyright = styled.p`
  color: #828282;
  align-self: flex-end;
 // margin-top: 53px;
  font: 400 12px Metrophobic, sans-serif;
  @media (max-width: 991px) {
   // margin-top: 40px;
    align-self: center;
  }
`;
const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  //padding: 20px;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
const NavigationLinks = styled.div`
  display: flex;
  justify-content: left;
  gap: 20px;
  margin-top: auto;
  margin-bottom:auto;
 // margin-bottom:5px;
  font: 600 22px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    font: 600 16px Metrophobic, sans-serif;
    margin-top: 40px;
    align-self: center;

  }
`;

const Link = styled.span`
  color: #202023;
  cursor: pointer;
`;